import React, { useState } from 'react';
import { Button } from '../ui/button';
import { INTERVIEW_OUTCOME_OPTIONS, OUTCOME_NEXT_STEPS } from '../../utils/hirelaneInterviewConstants';

export default function InterviewOutcomeModal({ roundLabel, onClose, onSubmit, submitting = false }) {
  const [outcome, setOutcome] = useState('Round Cleared');
  const [outcome_comments, setOutcomeComments] = useState('');
  const [next_recommended_step, setNextRecommendedStep] = useState('');

  const needsNextStep = outcome === 'Round Cleared' || outcome === 'Hold';

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!outcome_comments.trim()) return;
    if (needsNextStep && !next_recommended_step.trim()) return;
    onSubmit({
      outcome,
      outcome_comments: outcome_comments.trim(),
      next_recommended_step: needsNextStep ? next_recommended_step.trim() : null
    });
  };

  const valid =
    outcome_comments.trim() &&
    (!needsNextStep || OUTCOME_NEXT_STEPS.includes(next_recommended_step));

  return (
    <>
      <div className="hirelane-modal-backdrop" onClick={onClose} aria-hidden />
      <div className="hirelane-modal hirelane-modal--wide" role="dialog" aria-modal="true" aria-label="Interview result">
        <div className="hirelane-modal__header">
          <div style={{ fontWeight: 700, fontSize: 16 }}>Interview result — {roundLabel}</div>
          <Button type="button" variant="secondary" onClick={onClose}>
            Close
          </Button>
        </div>
        <form className="hirelane-modal__body" onSubmit={handleSubmit}>
          <label className="hirelane-detail__statusDecisionLabel">
            Outcome
            <select
              className="hirelane-detail__statusDecisionSelect"
              value={outcome}
              onChange={(e) => setOutcome(e.target.value)}
              required
            >
              {INTERVIEW_OUTCOME_OPTIONS.map((o) => (
                <option key={o} value={o}>
                  {o}
                </option>
              ))}
            </select>
          </label>

          <label className="hirelane-detail__statusDecisionLabel">
            Comments
            <textarea
              className="hirelane-detail__statusDecisionTextarea"
              value={outcome_comments}
              onChange={(e) => setOutcomeComments(e.target.value)}
              placeholder="Required: summarize the interview and rationale…"
              rows={5}
              required
            />
          </label>

          {needsNextStep ? (
            <label className="hirelane-detail__statusDecisionLabel">
              Next recommended step
              <select
                className="hirelane-detail__statusDecisionSelect"
                value={next_recommended_step}
                onChange={(e) => setNextRecommendedStep(e.target.value)}
                required
              >
                <option value="">Select…</option>
                {OUTCOME_NEXT_STEPS.map((s) => (
                  <option key={s} value={s}>
                    {s}
                  </option>
                ))}
              </select>
            </label>
          ) : null}

          <div className="hirelane-detail__statusDecisionActions">
            <Button type="button" variant="secondary" onClick={onClose}>
              Cancel
            </Button>
            <Button type="submit" disabled={submitting || !valid}>
              {submitting ? 'Saving…' : 'Save outcome'}
            </Button>
          </div>
        </form>
      </div>
    </>
  );
}
